import { useGetUserOnline } from '@practium/features/api';
import { useState } from 'react';
import styles from './MapWidget.module.css';
import BrazilMap from './BrazilMap';
import RegionPieChart from './RegionPieChart';
import Brain from './Brain';

type VisualizationType = 'map' | 'brain' | 'chart';

const OnlineUsersHeader = () => {
	const { data: totalUsers = 0 } = useGetUserOnline();

	return (
		<div className={styles.mapHeader}>
			<h2 className={styles.title}>
				{totalUsers} {totalUsers === 1 ? 'usuário online agora' : 'usuários online agora'}
			</h2>
			<p className={styles.subtitle}>Distribuição por localização</p>
		</div>
	);
};

export const MapWidget = () => {
	const [activeView, setActiveView] = useState<VisualizationType>('brain');

	const getTitle = () => {
		switch (activeView) {
			case 'map':
				return 'USUÁRIOS ONLINE AGORA';
			case 'brain':
				return 'O CÉREBRO DO PRACTIUM';
			case 'chart':
				return 'USUÁRIOS POR REGIÃO';
			default:
				return 'USUÁRIOS ONLINE AGORA';
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.topSection}>
				{activeView === 'map' ? (
					<OnlineUsersHeader />
				) : (
					<h2 className={styles.title}>{getTitle()}</h2>
				)}
				<div className={styles.content}>
					<div className={styles.imageWrapper}>
						{activeView === 'map' && <BrazilMap />}
						{activeView === 'brain' && <Brain />}
						{activeView === 'chart' && <RegionPieChart />}
					</div>
				</div>
			</div>
			<div className={styles.widgetSelector}>
				<button
					className={`${styles.widgetCard} ${activeView === 'chart' ? styles.active : ''}`}
					onClick={() => setActiveView('chart')}
					aria-label="Gráfico de pizza"
				>
					<img src="/images/pieChart.png" alt="Gráfico" className={styles.widgetIcon} />
				</button>
				<button
					className={`${styles.widgetCard} ${activeView === 'brain' ? styles.active : ''}`}
					onClick={() => setActiveView('brain')}
					aria-label="Visualizar cérebro"
				>
					<img src="/images/brain.png" alt="Cérebro" className={styles.widgetIcon} />
				</button>
				<button
					className={`${styles.widgetCard} ${activeView === 'map' ? styles.active : ''}`}
					onClick={() => setActiveView('map')}
					aria-label="Visualizar mapa"
				>
					<img src="/images/map.png" alt="Mapa" className={styles.widgetIcon} />
				</button>
			</div>
		</div>
	);
};
